import { render, staticRenderFns } from "./falseAlarmincident.vue?vue&type=template&id=b42671c2&"
import script from "./falseAlarmincident.vue?vue&type=script&lang=js&"
export * from "./falseAlarmincident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports